import { render, staticRenderFns } from "./EQuantidadeTipoDeAulas.vue?vue&type=template&id=4abf29eb&"
import script from "./EQuantidadeTipoDeAulas.vue?vue&type=script&lang=js&"
export * from "./EQuantidadeTipoDeAulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports